import React from "react";
import { getDate } from "../../../../assets/js/date-time-converter";

const OrderOverviewSelectedModules = (props) => {
  if (!props) {
    return null;
  }

  const { cartLineItems, textsMapping, goToStep } = props;

  const getSelectedCourseData = (product, selectedCourse, key) => {
    let selectedCourseDate;
    if (
      product === undefined ||
      selectedCourse === undefined ||
      selectedCourse === ""
    ) {
      return false;
    }

    function findCourse(startDateItem) {
      return startDateItem.courseId === product.selectedCourseId;
    }

    selectedCourseDate = product.availableStartDates.find(findCourse);

    if (selectedCourseDate === undefined) {
      return false;
    }

    if (key === "startDate") {
      selectedCourseDate = getDate(
        selectedCourseDate.startDateList[0].startTime
      );
      return <span>{selectedCourseDate}</span>;
    } else if (key === "city") {
      return <span>{selectedCourseDate.city}</span>;
    }
  };

  const renderSelectedModule = (lineItem) => {
    if (
      lineItem.selectedCourseId === "" ||
      lineItem.selectedCourseId === null
    ) {
      return;
    }

    return (
      <dl>
        <dt>{textsMapping.orderOverviewModuleScheduleNameLabel}</dt>
        <dd>{lineItem.title}</dd>

        <dt>{textsMapping.orderOverviewModuleScheduleStartDateLabel}</dt>
        <dd>
          {getSelectedCourseData(
            lineItem,
            lineItem.selectedCourseId,
            "startDate"
          )}
        </dd>

        <dt>{textsMapping.orderOverviewModuleScheduleLocationLabel}</dt>
        <dd>
          {getSelectedCourseData(lineItem, lineItem.selectedCourseId, "city")}
        </dd>
      </dl>
    );
  };

  return (
    <section className="checkout-section order-overview__selected-modules">
      <div className="checkout-section__header">
        <div className="checkout-section__header-text">
          <h3 className="checkout-section__title">
            {textsMapping.orderOverviewModuleScheduleTitle}
          </h3>
          <p>{textsMapping.orderOverviewModuleScheduleText}</p>
        </div>
        <button
          type="button"
          onClick={() => goToStep("jump", 0)}
          className="checkout-section__edit-link nev-icon nev-icon-pencil"
        >
          <span className="checkout-section__edit-link-text">
            {textsMapping.editLinkText}
          </span>
        </button>
      </div>

      {cartLineItems.map((lineItem) => {
        return (
          <div className="order-overview__module" key={lineItem.sku}>
            {lineItem.withPlanner ? renderSelectedModule(lineItem) : null}
          </div>
        );
      })}
    </section>
  );
};

export default OrderOverviewSelectedModules;
